export default {
  snack: '',
  snackColor: 'black',
  timeout: 5000
}
